import React from 'react';
import styled from 'styled-components';

import { Button } from 'playup-web-core';

import QuestionsAndHelp from '../USFooter/QuestionsAndHelp';
import formatCurrency from '../../../utils/formatCurrency';

const USDepositSuccessfulModal = ({ depositAmount, closeDepositModal }: Props) => {
	return (
		<DepositSuccessfulContainer>
			<NormalText>
				You have successfully deposited <BoldText>{formatCurrency(depositAmount)}</BoldText> into your PlayUp account.
			</NormalText>
			<StyledButton kind="playup" type="submit" height={50} onClick={closeDepositModal}>
				Continue
			</StyledButton>
			<QuestionsAndHelp />
		</DepositSuccessfulContainer>
	);
};

interface Props {
	depositAmount: number;
	closeDepositModal: () => void;
}

export default USDepositSuccessfulModal;

const DepositSuccessfulContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

const NormalText = styled.span`
	margin-bottom: 8px;
`;

const BoldText = styled.span`
	font-weight: 600;
`;
const StyledButton = styled(Button)`
	margin: 20px auto;
`;
